import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Uses localStorage
import { combineReducers } from '@reduxjs/toolkit';

import { chatApi } from 'src/pages/chat/slice/chatApi';
import { authApi } from 'src/pages/auth/slice/authApi';
import { ticketApi } from 'src/pages/tickets/slice/ticketApi';
import { tenantApi } from 'src/pages/tenants/slice/tenantsApi';
import { channelApi } from 'src/pages/channel/slice/channelApi';
import { settingApi } from 'src/pages/setting/slice/settingApi';
import { accountAPi } from 'src/pages/accounts/slice/accountsApi';
import { contactsApi } from 'src/pages/contacts/slice/contactsApi';
import { campaignApi } from 'src/pages/campaign/slice/campaignApi';
import { dashboardApi } from 'src/pages/dashborad/slice/dashboardApi';

import chatSlice from '../pages/chat/slice/chatSlice';
import authSlice from '../pages/auth/slice/authSlice';
import channelSlice from '../pages/channel/slice/channelSlice';
import settingSlice from '../pages/setting/slice/settingSlice';
import accountSlice from '../pages/accounts/slice/accountSlice';
import contactsSlice from '../pages/contacts/slice/contactsSlice';

// Configuration for redux-persist
const persistConfig = {
  key: 'root', // Key to store data
  storage, // Where to store (localStorage in this case)
  whitelist: ['auth'], // ✅ Persist only "auth"
};

const rootReducer = combineReducers({
  auth: authSlice,
  contact: contactsSlice,
  account: accountSlice,
  chat: chatSlice,
  channel: channelSlice,
  setting: settingSlice,
  [accountAPi.reducerPath]: accountAPi.reducer,
  [chatApi.reducerPath]: chatApi.reducer,
  [channelApi.reducerPath]: channelApi.reducer,
  [contactsApi.reducerPath]: contactsApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [settingApi.reducerPath]: settingApi.reducer,
  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [tenantApi.reducerPath]: tenantApi.reducer,
  [campaignApi.reducerPath]: campaignApi.reducer,
  [ticketApi.reducerPath]: ticketApi.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;
